export default {
  code: {
    500: '@:error.message.serverError',
    10001002: 'No resource can be found',
    10001004: 'Missing required parameter',
    10001005: 'No permission to access this resource',
    20003002: 'Your username or password is incorrect',
    20003003: 'Login code is invalid',
    20002003: 'Failed to get the WeChat article in draft, please visit Admin - Career/Brand Management - WeChat Message Management Template to configure the WeChat Official Account (AppID) and WeChat Official Account (AppKey) and save.',
    20002004: 'Failed to get wechat new messages, please try again later',
    20001001: 'This account has already been disabled. For any enquiries, please contact 400-990-3308',
    20001002: 'Oops, this is an HR account so you cannot participate ' +
      'in the referral program sorry. If you would like to manage your ' +
      'account please visit <span>www.ajinga.com</span> or download the AJINGA APP.',
    20001003: 'Oops, this is an EMPLOYEE account. Currently log in via ' +
      'WeChat is not supported for your account. Please ' +
      '<a href="">click HERE</a> to continue.',
    20001005: 'The Chinese or English name of the candidate status already exists',
    20005001: 'Oops! There is not enough points to transfer, please contact your account manager at AJINGA.',
    20005002: 'The WeChat Official Account has NOT yet been configured, please configure the official account first.',
    20005003: 'Please configure Page 1 firstly.',
    20005004: 'Please configure Page 1 firstly.',
    20005006: 'This is a referenced object, can not be deleted.',
    20005007: 'You can not set parent to its child company.',
    20005008: 'This company has been registered.',
    20005009: 'An account is already exist with this username',
    20008001: 'Cannot create, group name already exists.',
    20008002: 'Cannot create or update, Question title already exists.',
    20008003: 'Empty answer of the questionnaire.',
    20008004: 'No questionnaires of the job.',
    20009001: 'You cannot create more job, contact AJINGA team to increase it.',
    20009002: '3rd Party ATS ID has been mapped to another job.',
    20009003: 'Oops, seems the number of live job on LinkedIn reached the limit. Please coordinate with your LinkedIn admin or AJINGA client success manager for further support.',
    20009004: '51job posting points are not enough, please contact admin!',
    20010001: 'Only one NPS question per question',
    20010002: 'Only one NPS question per question',
    20010003: 'This type of questionnaire cannot be duplicate',
    20010004: 'Includes the steps of the questionnaire contains NPS questions already',
    20010005: 'Cannot create or update, Questionnaire name already exists.',
    20010006: 'Answers are longer than the limit',
    20011001: 'This email has been registered as a non-candidate account, please enter another email.',
    20011002: 'This email account can not apply this job, please enter another email.',
    20011003: 'This email account has already applied for this position, please enter another email.',
    20011004: 'This email account has already used, please enter another email.',
    20011005: 'The current locking rule is in use and cannot be modified',
    20011006: 'Oops! You cannot upload this candidate. A candidate with this email and/or mobile phone number, already exists in the talent pool.',
    20011007: 'A candidate should has email or mobile phone number.',
    20011010: 'The candidate you uploaded may be already existed in talent pool. Please contact responsible recruiter for more details.',
    20007001: 'Your username or password is incorrect',
    20007002: 'Your username or password is incorrect',
    20007003: 'Your username or password is incorrect',
    20007004: 'Create password failed, Not found HM!',
    20007005: 'Account does not exist. Please contact your administrator.',
    20007006: 'Can not reset password more than 5 times in 24 hours!',
    20006021: 'Can not reset password more than 5 times in 24 hours!',
    20006043: 'Lack Teams permission',
    20007007: 'Create password has expired, please redo forgot password!',
    20007008: 'This invitation has been rating and cannot be rating again!',
    60010001: 'Only one account can be created on the same platform in the same company',
    20002008: 'Has already started to task cannot be modified!',
    20002009: 'Tag id list is not correct, please check it',
    20002011: 'This talent filter group parent has over max limit parent',
    20002012: 'Microsite group already used, can not delete!',
    20002013: 'Zoom user email not found',
    20012001: 'That policy already exists.',
    20012002: 'That policy is enabled and editing is not allowed.',
    20012003: 'You have already sent 3 consent collection email. If you have any further question, please contact candidate or account manager at AJINGA for support',
    20015001: 'Oops, seems you have already upload this ambassador.',
    20015002: 'For each record you must have either an email address OR a mobile telephone number (or both) ',
    20015003: 'The job poster ambassador no exist',
    20016001: 'A user is already registered with this email address.',
    20016002: 'Oops, seems this email has been already registered as agency in current company.',
    20017001: 'This name is used.',
    20018001: "Oops! We hit a snag while summarizing your resume. We're working to fix it as quickly as possible. Please try again in a few minutes!",
    20018002: "Oops! We hit a snag while summarizing your resume. We're working to fix it as quickly as possible. Please try again in a few minutes!",
    20020001: 'The source code is duplicated with AJINGA global one, please check with your AJINGA client success manager for more information.',
    20021000: 'Questionnaire management business error',
    20021001: 'Company is required',
    20021002: 'Inherited resources are read-only',
    20021003: 'The value must be an integer',
    20021004: 'Status must be enabled or disabled',
    20021116: 'Score scale type is invalid',
    20021117: 'Score scale configuration is invalid',
    20021201: 'Question not found',
    20021202: 'Question is outside the current company scope',
    20021203: 'Question is locked and cannot be edited',
    20021204: 'Question is disabled',
    20021205: 'Question title is required',
    20021206: 'Question type is invalid',
    20021207: 'Options are only allowed for select questions',
    20021208: 'Select questions need at least two options',
    20021209: 'Question option item must be an object',
    20021210: 'Option sort order must be an integer',
    20021211: 'Option sort order is duplicated',
    20021212: 'Option label is required',
    20021301: 'Questionnaire not found',
    20021302: 'Questionnaire is outside the current company scope',
    20021303: 'Questionnaire name is required',
    20021304: 'Questionnaire items must be a list',
    20021305: 'Questionnaire item not found',
    20021306: 'Questionnaire item must be an object',
    20021307: 'Question ID must be an integer',
    20021308: 'Questionnaire item does not match the question ID',
    20021309: 'Question is duplicated in the questionnaire',
    20021310: 'Questionnaire item sort order is duplicated',
    20021311: 'Please select a score scale when rating questions exist',
    20021312: 'The total score weight of rating questions must equal 100%',
    20021313: 'Questionnaire structure is locked and question structure cannot be changed',
    20021314: 'Sort order must be an integer',
    20021315: 'Score weight must be a number',
    20021316: 'Score weight is required for rating questions',
    20021317: 'Score weight must be between 0 and 100',
    20021318: 'Score weight is only allowed for rating questions',
    20021402: 'Questionnaire usage type is invalid',
    20021403: 'Legacy invite record not found',
    20021404: 'Legacy invite record has no questionnaire ID',
    20021405: 'Runtime context type is invalid',
    20021406: 'Runtime questionnaire item not found',
    20021407: 'Required answer is missing',
    20021408: 'Runtime response has been finalized and is read-only',
    20021409: 'Runtime questionnaire record has no questionnaire ID',
    20021410: 'Manual runtime does not accept answers',
    20021502: 'Select at least two candidates for a group interview.',
    20021503: 'Select at least two hiring managers for a group interview.',
    20021504: 'Enter a group interview name.',
    20021505: 'The group interview name cannot exceed 255 characters.',
    20021506: 'Select a questionnaire before assigning interviewers.',
    20021507: 'The selected group interview questionnaire is invalid.',
    20021508: 'The selected group interview questionnaire contains no questions.',
    20021509: 'The questionnaire item assignment is invalid.',
    20021510: 'Assign at least one interviewer to each question.',
    20021511: 'The assigned interviewer is not included in this invitation.',
    20021513: 'Assign an interviewer to every questionnaire item.',
    20021514: 'Assign at least one question to every invited hiring manager.',
    20006018: 'Oops, you have reached SMS verification code sending limitation, please try again after 24 hrs.',
    20006020: 'Your account has been disabled',
    20006024: 'The mobile number has already been bound',
    20006025: 'Please contact AJINGA to add additional accounts',
    20006042: 'The email or phone account is disabled',
    20006008: 'A user is already registered with this email address',
    20006009: 'Password must contain small letter, capital letter and number, and at least 10 digit, symbol can only use _#@.-',
    20006010: 'Incorrect mobile phone number or SMS code',
    20006013: 'Captcha is invalid or expired, please refresh the captcha!',
    20006027: 'Enter a valid e-mail address or a user is already registered with this email address',
    20006029: 'Update account mobile failed',
    20006030: 'This is the mobile you are currently using',
    20006032: 'This email is a candidate account, cannot be admin!',
    20006033: 'This email is an employee account, cannot be admin!',
    20006034: 'Account has a related company',
    20006035: 'This email already has the selected role!',
    20006036: 'Account does not exist',
    20006037: 'The number of delete users has been used up, 100 times per day',
    20006038: 'Please input a valid email.',
    20006039: 'The email has been used, please enter the logged out email again!',
    20006040: 'Wrong password',
    20006041: 'Please make sure the two passwords are the same.',
    70001002: 'Email layout template not exist',
    70001003: 'Duplicate commit',
    70001004: 'Email template not exist',
    70001005: 'System template can not edit',
    70001006: 'Please input a different name',
    70001007: 'Email template type not exist',
    70001008: 'The template is already in use and cannot be deleted!',
    20011008: 'This job has a fixed-status-change-progression-logic due to the referral rewards program. Please update the next status in line with the referral progression logic. ',
    20011009: 'This job has a fixed-status-change-progression-logic due to the referral rewards program. Please update the next status in line with the referral progression logic. ',
    20011011: 'This job has a fixed headcount due to the referral rewards program. Please either adjust the headcount in the referral program, or select a different status. ',
    20011012: 'Upload failed: For security reasons, this file type or content has been blocked by the system.',
    20011013: 'Upload failed: For security reasons, this file type or content has been blocked by the system.',
    90000001: 'The mobile phone number format does not meet the requirements! You cannot invite AI for an interview.',
    90000002: 'The email or phone must has one',
    90000003: 'Email and mobile is required. Please add email and mobile to candidate and invite again.',
    90000004: 'Service configuration error. Please coordinate with your AJINGA client success manager for further support.'
  },
  message: {
    serverError: 'An error occurred on the server. Please try again later'
  },
  page: {
    internalOnlyMicroSite: {
      title: 'You\'re not an internal employee yet',
      message: {
        notEmployee: 'Oops!',
        onlyInternal: 'This is an employee-only page!',
        toRegister: {
          prefix: 'If you ARE an EMPLOYEE of {companyName}, please tap ',
          content: 'HERE',
          suffix: ' to register / login.',
          inactive: 'You employee account has not been activated yet, please check the activation email or contact your HR.'
        }
      }
    },
    noAccessToComapnySurvey: {
      title: 'You don\'t have access to this survey',
      notCompanyEmployee: 'You are not an employee of {companyName} and have no access to this survey. ',
      employeeNoPass: 'Your employee status is still under review. Please contact HR.'
    },
    linkExpired: {
      title: 'Link Expired',
      content: 'Due to our candidate privacy and data security policy, <br>this link was de-activated after 30 days.'
    }
  }
}
